import { Sun } from "lucide-react";
import { Link } from "react-router-dom";

export default function AgencyFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="agency-footer"
      className="relative border-t border-white/5 py-12 lg:py-16"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">
        <div className="flex flex-col lg:flex-row gap-10 lg:items-end lg:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="grid place-items-center h-9 w-9 rounded-full bg-brand-yellow text-brand-yellowFg">
                <Sun strokeWidth={2.4} className="h-5 w-5" />
              </span>
              <span className="font-heading font-extrabold text-xl tracking-tight text-white">
                Heliora
              </span>
            </div>
            <p className="mt-4 text-sm text-white/45 max-w-sm leading-relaxed">
              Agencja marketingowa dla branży fotowoltaicznej i instalacyjnej.
              Strony, formularze, kampanie — wszystko, co przynosi telefony.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-7 gap-y-3 text-sm">
            <Link to="/przyklad-strony" className="text-white/70 hover:text-white" data-testid="footer-link-przyklad">
              Przykład strony
            </Link>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-white/35">
          <div>© {year} Heliora. Wszystkie prawa zastrzeżone.</div>
          <div>Polska</div>
        </div>
      </div>
    </footer>
  );
}
